import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'regiao');

const regiaoActions = {
  ...genericActions(basePath),
  listarAtivosPorRepresentante: { method: 'GET', url: `${basePath}/por-representante?&nome={nome}&indAtivo=true&colunaOrdenacao=nom_regiao` },
};

export default resource => resource(`${basePath}`, {}, regiaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/regiao.js